// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-button-sm[data-v-684180c5]{height:35px;width:35px;font-size:.875rem;padding:.7rem}.p-component[data-v-684180c5]:disabled,.p-disabled[data-v-684180c5]{opacity:.8}.p-dropdown[data-v-684180c5]{min-width:200px}", ""]);
// Exports
module.exports = exports;
